// @flow
import environment from '../../environment';
import { postCreator } from '../../http';

export type TiendaRequest = {
  name: string;
  shopName: string;
  phone: string;
  email: string;
};

export const endpoints = Object.freeze({
  REGISTER_STORE: `${environment.apiUrl}/shop/lead/register`,
});

export const registerStoreApi = postCreator(fetch, endpoints.REGISTER_STORE);



// WEBPACK FOOTER //
// ./src/modules/tiendas/api.js